import PageHero, { usePageTitle } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const SECTIONS = [
  {
    title: "Responsable",
    body: "BRIK Procurement Partners, es responsable del tratamiento y protección de los datos personales recabados a través de este sitio web y otros medios de contacto.",
  },
  {
    title: "Datos que podemos recabar",
    body: "Podremos recabar datos de identificación y contacto, información profesional y laboral, así como información comercial o empresarial necesaria para atender solicitudes, prestar nuestros servicios o evaluar posibles relaciones profesionales y comerciales.\n\nNo solicitamos intencionalmente datos personales sensibles a través de nuestro sitio web.",
  },
  {
    title: "¿Para qué utilizamos sus datos?",
    body: "Sus datos podrán ser utilizados para:",
    list: [
      "Atender solicitudes de información, contacto y cotización.",
      "Evaluar, prestar y dar seguimiento a nuestros servicios.",
      "Mantener relaciones con clientes, prospectos, proveedores y aliados.",
      "Evaluar candidatos y perfiles profesionales recibidos a través de nuestra sección de Talento.",
      "Enviar información sobre servicios, contenidos o novedades de BRIK, cuando corresponda.",
      "Cumplir obligaciones legales, contractuales y administrativas.",
    ],
  },
  {
    title: "Transferencia y protección de información",
    body: "BRIK podrá compartir información con proveedores de servicios necesarios para su operación o cuando exista una obligación legal para hacerlo, aplicando las medidas de protección y confidencialidad correspondientes.",
  },
  {
    title: "Derechos ARCO",
    body: "Usted puede solicitar el Acceso, Rectificación, Cancelación u Oposición al tratamiento de sus datos personales, así como solicitar la revocación de su consentimiento o limitar su uso.",
    contact: true,
  },
  {
    title: "Cookies",
    body: "Nuestro sitio podrá utilizar cookies y tecnologías similares para su funcionamiento, análisis y mejora de la experiencia de navegación. Estas podrán administrarse desde la configuración de su navegador o, cuando corresponda, mediante las herramientas disponibles en el sitio.",
  },
  {
    title: "Cambios al aviso",
    body: "BRIK Procurement Partners podrá actualizar este Aviso de Privacidad. La versión vigente estará disponible permanentemente en nuestro sitio web.",
  },
];

export default function AvisoPrivacidad() {
  usePageTitle("Aviso de Privacidad | BRIK Procurement Partners");
  return (
    <>
      <PageHero
        eyebrow="Última actualización: septiembre 2026"
        titleLines={["Aviso de Privacidad"]}
        description="En BRIK Procurement Partners respetamos y protegemos la privacidad de nuestros clientes, prospectos, proveedores, aliados, candidatos y usuarios de nuestro sitio web."
      />

      <section data-testid="privacy-content" className="bg-bone">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
          <div className="border-t border-oxford/10 divide-y divide-oxford/10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={Math.min(i * 0.05, 0.25)}>
                <div className="py-10" data-testid={`privacy-section-${i + 1}`}>
                  <div className="flex items-baseline gap-5">
                    <span className="font-display text-sm font-semibold text-gold shrink-0">{String(i + 1).padStart(2, "0")}</span>
                    <div>
                      <h2 className="font-display text-lg lg:text-xl font-semibold text-oxford">{s.title}</h2>
                      {s.body.split("\n\n").map((p, j) => (
                        <p key={j} className="mt-4 text-sm lg:text-base leading-relaxed text-carbon/75">
                          {p}
                        </p>
                      ))}
                      {s.list && (
                        <ul className="mt-4 space-y-2.5">
                          {s.list.map((item) => (
                            <li key={item} className="flex items-start gap-3 text-sm lg:text-base leading-relaxed text-carbon/75">
                              <span className="mt-2 h-1.5 w-1.5 bg-gold rotate-45 shrink-0" />
                              {item}
                            </li>
                          ))}
                        </ul>
                      )}
                      {s.contact && (
                        <p className="mt-4 text-sm lg:text-base text-carbon/75">
                          Para ejercer estos derechos, puede contactarnos en:{" "}
                          <a href={`mailto:${CONTACT.email}`} data-testid="privacy-email" className="font-medium text-oxford underline decoration-gold underline-offset-4 hover:text-gold transition-colors">
                            {CONTACT.email}
                          </a>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-8 border-t-2 border-gold pt-8">
              <p className="font-display text-sm font-semibold text-oxford">BRIK Procurement Partners</p>
              <p className="mt-2 text-sm text-carbon/70">{CONTACT.location}</p>
              <p className="text-sm text-carbon/70">{CONTACT.website}</p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
